import type { SignInSurface } from "./events";

/**
 * "Open the Save your room prompt" requests from outside the component
 * that owns it (`SaveRoomSheet`, mounted in `App.tsx`). The feng shui
 * guide's "Save it" step and the post-first-layout moment both use it,
 * so the ask always looks the same: Google, Apple and email, after the
 * visitor has seen value.
 */
export interface SavePromptRequest {
  surface: SignInSurface;
}

let pending: SavePromptRequest | null = null;
const listeners = new Set<(req: SavePromptRequest) => void>();

function flush() {
  if (!pending || listeners.size === 0) return;
  const req = pending;
  pending = null;
  for (const l of listeners) l(req);
}

export function requestSavePrompt(req: SavePromptRequest): void {
  pending = req;
  flush();
}

export function subscribeSavePromptRequests(listener: (req: SavePromptRequest) => void): () => void {
  listeners.add(listener);
  if (pending) queueMicrotask(flush);
  return () => {
    listeners.delete(listener);
  };
}

/** Test-only: drop an undelivered request. */
export function _resetSavePromptRequestsForTests(): void {
  pending = null;
}
